import MarketPlace1 from "@assets/KPMG/MarketPlace1.svg";
import MarketPlace2 from "@assets/KPMG/MarketPlace2.svg";
import Desigo from "@assets/KPMG/infratech/Desigo.png";
import ABB from "@assets/KPMG/infratech/ABB.jpg";
import Delta from "@assets/KPMG/infratech/Delta.jpg";
import Honeywell from "@assets/KPMG/infratech/Honeywell.jpg";
import Simens from "@assets/KPMG/infratech/simens.png";
import Intel from "@assets/KPMG/infratech/intel.png";
import Electric from "@assets/KPMG/infratech/electric.png";
import Trane from "@assets/KPMG/infratech/Trane.jpg";
import Philips from "@assets/KPMG/infratech/Philips.jpg";
import KPMG from "@assets/KPMG/infratech/KPMG.jpg";
import PowerAutomation from "@assets/KPMG/infratech/PowerAutomation.jpg";
import SchneiderElectric from "@assets/KPMG/infratech/SchneiderElectric.jpg";
import Signify from "@assets/KPMG/infratech/Signify.jpg";
import AbsoluteInspection from "@assets/KPMG/infratech/AbsoluteInspection.jpg";
import SolarCity from "@assets/KPMG/infratech/SolarCity.jpg";
import Sunnova from "@assets/KPMG/infratech/Sunnova.jpg";
import Charge from "@assets/KPMG/infratech/Charge+.jpg";
import VivintSolar from "@assets/KPMG/infratech/VivintSolar.jpg";
import SolarGy from "@assets/KPMG/infratech/SolarGy.jpg";
import SolarEdge from "@assets/KPMG/infratech/SolarEdge.jpg";
import SunpPro from "@assets/KPMG/infratech/SunpPro.jpg";
import SolarPVExchange from "@assets/KPMG/infratech/SolarPVExchange.jpg";
import iSwitch from "@assets/KPMG/infratech/iSwitch.jpg";
import Sunrun from "@assets/KPMG/infratech/Sunrun.jpg";
import SunPower from "@assets/KPMG/infratech/SunPower.jpg";
import SunseapGroup from "@assets/KPMG/infratech/SunseapGroup.jpg";
import EV from "@assets/KPMG/infratech/EV.svg";

export const mockData: any = {
  title: "Connected Buildings Offerings",
  code: "waterSupply",
  description:
    "Transform your buildings into smarter and greener by bringing seamless connectivity from floor to floor. Harness the power of data collection to unlock valuable insights that will propel the business forward",
  projectList: [
    {
      title: "R-Tap by Hiraya Water",
      category: "Water Supply",
      categoryIcon: MarketPlace1,
      location: "Philippine",
      rating: "4.0",
      description:
        "Intelligent Supply and pressure managementsystem that transforms water distribution system into their most efficient version",
      developer: "Hiraya Water",
      techAdoption: "AI, IOT, Data Analytics",
      solution: "",
      provider: "",
      type: "",
    },
    {
      title: "Ecox Structure",
      category: "Water Supply",
      categoryIcon: MarketPlace2,
      location: "Philippine",
      rating: "4.0",
      description:
        "Intelligent Supply and pressure managementsystem that transforms water distribution system into their most efficient version",
      developer: "Hiraya Water",
      techAdoption: "AI, IOT, Data Analytics",
    },
  ],
};

export const mockDataMultiple: any = {
  title: "Connected Buildings Offerings",
  code: "waterSupply",
  description:
    "Transform your buildings into smarter and greener by bringing seamless connectivity from floor to floor. Harness the power of data collection to unlock valuable insights that will propel the business forward",
  projectList: [
    {
      id: 1,
      title: "EcoxStructure",
      category: "Building ",
      categoryIcon: Desigo,
      location: "Singapore",
      rating: "4.0",
      description:
        "Connecting everything in your enterprise from shop floor to the top floor. Collecting critical data, analysing data and discover meaningful insights.",
      developer: "Schneider Electric",
      techAdoption: "AI, IoT, Data Analytics",
      solution: "Smart Building Solutions",
      provider: "Schneider Electric",
      type: "Package Solutions",
    },
    {
      id: 2,
      title: "SmartxStructure BMS",
      category: "Building ",
      categoryIcon: MarketPlace2,
      location: "Singapore",
      rating: "4.0",
      description:
        "Connecting everything in your enterprise from shop floor to the top floor. Collecting critical data, analysing data and discover meaningful insights.",
      developer: "Schneider Electric",
      techAdoption: "AI, IoT, Data Analytics",
      solution: "Smart Building Solutions",
      provider: "Schneider Electric",
      type: "Package Solutions",
    },
    {
      id: 3,
      title: "Verasys BAS",
      category: "Building ",
      categoryIcon: MarketPlace2,
      location: "Singapore",
      rating: "4.0",
      description:
        "Connecting everything in your enterprise from shop floor to the top floor. Collecting critical data, analysing data and discover meaningful insights.",
      developer: "Schneider Electric",
      techAdoption: "AI, IoT, Data Analytics",
      solution: "Smart Building Solutions",
      provider: "Johnson Controls",
      type: "Package Solutions",
    },
    {
      id: 4,
      title: "Metasys BAS",
      category: "Building ",
      categoryIcon: MarketPlace2,
      location: "Singapore",
      rating: "4.0",
      description:
        "Connecting everything in your enterprise from shop floor to the top floor. Collecting critical data, analysing data and discover meaningful insights.",
      developer: "Schneider Electric",
      techAdoption: "AI, IoT, Data Analytics",
      solution: "Smart Building Solutions",
      provider: "Johnson Controls",
      type: "Package Solutions",
    },
    {
      id: 5,
      category: "Building ",
      categoryIcon: Simens,
      location: "Singapore",
      rating: "4.0",
      description:
        "Connecting everything in your enterprise from shop floor to the top floor. Collecting critical data, analysing data and discover meaningful insights.",
      developer: "Schneider Electric",
      techAdoption: "AI, IoT, Data Analytics",
      solution: "Smart Building Solutions",
      title: "Siemens",
      provider: "Desigo BMS",
      type: "Package Solutions",
    },
    {
      id: 6,
      category: "Building ",
      categoryIcon: Honeywell,
      location: "Singapore",
      rating: "4.0",
      description:
        "Connecting everything in your enterprise from shop floor to the top floor. Collecting critical data, analysing data and discover meaningful insights.",
      developer: "Schneider Electric",
      techAdoption: "AI, IoT, Data Analytics",
      solution: "Smart Building Solutions",
      title: "Comfort Point Open BMS",
      provider: "Honeywell",
      type: "Package Solutions",
    },
    {
      id: 7,
      category: "Building ",
      categoryIcon: Honeywell,
      location: "Singapore",
      rating: "4.0",
      description:
        "Connecting everything in your enterprise from shop floor to the top floor. Collecting critical data, analysing data and discover meaningful insights.",
      developer: "Schneider Electric",
      techAdoption: "AI, IoT, Data Analytics",
      title: "Enterprise Building Integrator",
      provider: "Honeywell",
      type: "Package Solutions",
    },
    {
      id: 8,
      category: "Building ",
      categoryIcon: Delta,
      location: "Singapore",
      rating: "4.0",
      description:
        "Connecting everything in your enterprise from shop floor to the top floor. Collecting critical data, analysing data and discover meaningful insights.",
      developer: "Schneider Electric",
      techAdoption: "AI, IoT, Data Analytics",
      solution: "Smart Building Solutions",
      title: "enteliWEB",
      provider: "Delta",
      type: "Package Solutions",
    },
    {
      id: 9,
      category: "Building ",
      categoryIcon: ABB,
      location: "Singapore",
      rating: "4.0",
      description:
        "Connecting everything in your enterprise from shop floor to the top floor. Collecting critical data, analysing data and discover meaningful insights.",
      developer: "Schneider Electric",
      techAdoption: "AI, IoT, Data Analytics",
      solution: "Smart Building Solutions",
      title: "Newron Solution",
      provider: "ABB",
      type: "Package Solutions",
    },
    {
      id: 10,
      category: "Building ",
      categoryIcon: Trane,
      location: "Singapore",
      rating: "4.0",
      description:
        "Connecting everything in your enterprise from shop floor to the top floor. Collecting critical data, analysing data and discover meaningful insights.",
      developer: "Schneider Electric",
      techAdoption: "AI, IoT, Data Analytics",
      solution: "Smart Building Solutions",
      title: "Tracer Ensemble",
      provider: "Trane",
      type: "Package Solutions",
    },
    {
      id: 11,
      category: "Building ",
      categoryIcon: Philips,
      location: "Singapore",
      rating: "4.0",
      description:
        "Connecting everything in your enterprise from shop floor to the top floor. Collecting critical data, analysing data and discover meaningful insights.",
      developer: "Schneider Electric",
      techAdoption: "AI, IoT, Data Analytics",
      solution: "Smart Building Solutions",
      title: "Smart Lighting for Smart Building",
      provider: "Philips",
      type: "Technologies",
    },
    {
      id: 12,
      category: "Building ",
      categoryIcon: PowerAutomation,
      location: "Singapore",
      rating: "4.0",
      description:
        "Connecting everything in your enterprise from shop floor to the top floor. Collecting critical data, analysing data and discover meaningful insights.",
      developer: "Schneider Electric",
      techAdoption: "AI, IoT, Data Analytics",
      solution: "Smart Building Solutions",
      title: "Cloud Computing ",
      provider: "Power Automation",
      type: "Technologies",
    },
    {
      id: 13,
      category: "Building ",
      categoryIcon: PowerAutomation,
      location: "Singapore",
      rating: "4.0",
      description:
        "Connecting everything in your enterprise from shop floor to the top floor. Collecting critical data, analysing data and discover meaningful insights.",
      developer: "Schneider Electric",
      techAdoption: "AI, IoT, Data Analytics",
      solution: "Smart Building Solutions",
      title: "Data Analytics and AI",
      provider: "Power Automation",
      type: "Technologies",
    },
    {
      id: 14,
      category: "Building ",
      categoryIcon: SchneiderElectric,
      location: "Singapore",
      rating: "4.0",
      description:
        "Connecting everything in your enterprise from shop floor to the top floor. Collecting critical data, analysing data and discover meaningful insights.",
      developer: "Schneider Electric",
      techAdoption: "AI, IoT, Data Analytics",
      solution: "Smart Building Solutions",
      title: "Cybersecurity ",
      provider: "Schneider Electric",
      type: "Technologies",
    },
    {
      id: 15,
      category: "Building ",
      categoryIcon: Signify,
      location: "Singapore",
      rating: "4.0",
      description:
        "Connecting everything in your enterprise from shop floor to the top floor. Collecting critical data, analysing data and discover meaningful insights.",
      developer: "Schneider Electric",
      techAdoption: "AI, IoT, Data Analytics",
      solution: "Smart Building Solutions",
      title: "Light as Services",
      provider: "Signify",
      type: "Services",
    },
    {
      id: 16,
      category: "Building ",
      categoryIcon: AbsoluteInspection,
      location: "Singapore",
      rating: "4.0",
      description:
        "Connecting everything in your enterprise from shop floor to the top floor. Collecting critical data, analysing data and discover meaningful insights.",
      developer: "Schneider Electric",
      techAdoption: "AI, IoT, Data Analytics",
      solution: "Smart Building Solutions",
      title: "Building Inspection",
      provider: "Absolute Inspection",
      type: "Services",
    },
    {
      id: 17,
      category: "Building ",
      categoryIcon: KPMG,
      location: "Singapore",
      rating: "4.0",
      description:
        "Connecting everything in your enterprise from shop floor to the top floor. Collecting critical data, analysing data and discover meaningful insights.",
      developer: "Schneider Electric",
      techAdoption: "AI, IoT, Data Analytics",
      solution: "Smart Building Solutions",
      title: "Smart Building Consultation",
      provider: "KPMG",
      type: "Services",
    },
    {
      id: 18,
      category: "Building ",
      categoryIcon: SolarCity,
      location: "Singapore",
      rating: "4.0",
      description:
        "Connecting everything in your enterprise from shop floor to the top floor. Collecting critical data, analysing data and discover meaningful insights.",
      developer: "Schneider Electric",
      techAdoption: "AI, IoT, Data Analytics",
      solution: "Solar Panel Solutions",
      title: "Solar Panel as A Service",
      provider: "Solar City",
      type: "Package Solutions",
    },
    {
      id: 19,
      category: "Building ",
      categoryIcon: Sunnova,
      location: "Singapore",
      rating: "4.0",
      description:
        "Connecting everything in your enterprise from shop floor to the top floor. Collecting critical data, analysing data and discover meaningful insights.",
      developer: "Schneider Electric",
      techAdoption: "AI, IoT, Data Analytics",
      solution: "Solar Panel Solutions",
      title: "Solar Panel as A Service",
      provider: "Sunnova",
      type: "Package Solutions",
    },
    {
      id: 20,
      category: "Building ",
      categoryIcon: SolarEdge,
      location: "Singapore",
      rating: "4.0",
      description:
        "Connecting everything in your enterprise from shop floor to the top floor. Collecting critical data, analysing data and discover meaningful insights.",
      developer: "Schneider Electric",
      techAdoption: "AI, IoT, Data Analytics",
      solution: "Solar Panel Solutions",
      title: "Solar Panel Monitoring",
      provider: "Solar Edge",
      type: "Technologies",
    },
    {
      id: 21,
      category: "Building ",
      categoryIcon: SunpPro,
      location: "Singapore",
      rating: "4.0",
      description:
        "Connecting everything in your enterprise from shop floor to the top floor. Collecting critical data, analysing data and discover meaningful insights.",
      developer: "Schneider Electric",
      techAdoption: "AI, IoT, Data Analytics",
      solution: "Solar Panel Solutions",
      title: "Solar Panel Installation & Maintenance",
      provider: "SunpPro",
      type: "Services",
    },
    {
      id: 22,
      category: "Building ",
      categoryIcon: SolarGy,
      location: "Singapore",
      rating: "4.0",
      description:
        "Connecting everything in your enterprise from shop floor to the top floor. Collecting critical data, analysing data and discover meaningful insights.",
      developer: "Schneider Electric",
      techAdoption: "AI, IoT, Data Analytics",
      solution: "Solar Panel Solutions",
      title: "Solar Panel Installation & Maintenance",
      provider: "SolarGy",
      type: "Services",
    },
    {
      id: 23,
      category: "Building ",
      categoryIcon: SolarPVExchange,
      location: "Singapore",
      rating: "4.0",
      description:
        "Connecting everything in your enterprise from shop floor to the top floor. Collecting critical data, analysing data and discover meaningful insights.",
      developer: "Schneider Electric",
      techAdoption: "AI, IoT, Data Analytics",
      solution: "Solar Panel Solutions",
      title: "Solar Panel Installation & Maintenance",
      provider: "SolarPV Exchange",
      type: "Services",
    },
    {
      id: 24,
      category: "Building ",
      categoryIcon: iSwitch,
      location: "Singapore",
      rating: "4.0",
      description:
        "Connecting everything in your enterprise from shop floor to the top floor. Collecting critical data, analysing data and discover meaningful insights.",
      developer: "Schneider Electric",
      techAdoption: "AI, IoT, Data Analytics",
      solution: "Solar Panel Solutions",
      title: "Solar Panel Installation & Maintenance",
      provider: "iSwitch",
      type: "Services",
    },
    {
      id: 25,
      category: "Building ",
      categoryIcon: iSwitch,
      location: "Singapore",
      rating: "4.0",
      description:
        "Connecting everything in your enterprise from shop floor to the top floor. Collecting critical data, analysing data and discover meaningful insights.",
      developer: "Schneider Electric",
      techAdoption: "AI, IoT, Data Analytics",
      solution: "Solar Panel Solutions",
      title: "Solar Panel Installation & Maintenance",
      provider: "iSwitch",
      type: "Services",
    },
    {
      id: 26,
      title: "Solar Panel as A Service",
      category: "Building ",
      categoryIcon: Sunrun,
      location: "Singapore",
      rating: "4.0",
      description:
        "Connecting everything in your enterprise from shop floor to the top floor. Collecting critical data, analysing data and discover meaningful insights.",
      developer: "Schneider Electric",
      techAdoption: "AI, IoT, Data Analytics",
      solution: "Solar Panel Solutions",
      provider: "Sun Run",
      type: "Package Solutions",
    },
    {
      id: 27,
      title: "Solar Panel as A Service",
      category: "Building ",
      categoryIcon: SunPower,
      location: "Singapore",
      rating: "4.0",
      description:
        "Connecting everything in your enterprise from shop floor to the top floor. Collecting critical data, analysing data and discover meaningful insights.",
      developer: "Schneider Electric",
      techAdoption: "AI, IoT, Data Analytics",
      solution: "Solar Panel Solutions",
      provider: "SunPower",
      type: "Package Solutions",
    },
    {
      id: 28,
      title: "Solar Panel as A Service",
      category: "Building ",
      categoryIcon: VivintSolar,
      location: "Singapore",
      rating: "4.0",
      description:
        "Connecting everything in your enterprise from shop floor to the top floor. Collecting critical data, analysing data and discover meaningful insights.",
      developer: "Schneider Electric",
      techAdoption: "AI, IoT, Data Analytics",
      solution: "Solar Panel Solutions",
      provider: "Vivint Solar",
      type: "Package Solutions",
    },
    {
      id: 29,
      title: "Solar Panel Installation & Maintenance",
      category: "Building ",
      categoryIcon: SunseapGroup,
      location: "Singapore",
      rating: "4.0",
      description:
        "Connecting everything in your enterprise from shop floor to the top floor. Collecting critical data, analysing data and discover meaningful insights.",
      developer: "Schneider Electric",
      techAdoption: "AI, IoT, Data Analytics",
      solution: "Solar Panel Solutions",
      provider: "Sunseap Group",
      type: "Package Solutions",
    },
    {
      id: 30,
      title: "EV Charging Installation & Maintenance",
      category: "Building ",
      categoryIcon: Intel,
      location: "Singapore",
      rating: "4.0",
      description:
        "Connecting everything in your enterprise from shop floor to the top floor. Collecting critical data, analysing data and discover meaningful insights.",
      developer: "Schneider Electric",
      techAdoption: "AI, IoT, Data Analytics",
      solution: "EV Solutions",
      provider: "Greenlots",
      type: "Services",
    },
    {
      id: 31,
      title: "EV Charging Installation & Maintenance",
      category: "Building ",
      categoryIcon: Charge,
      location: "Singapore",
      rating: "4.0",
      description:
        "Connecting everything in your enterprise from shop floor to the top floor. Collecting critical data, analysing data and discover meaningful insights.",
      developer: "Schneider Electric",
      techAdoption: "AI, IoT, Data Analytics",
      solution: "EV Solutions",
      provider: "Charge+",
      type: "Services",
    },
    {
      id: 32,
      title: "EV Charging Installation & Maintenance",
      category: "Building ",
      categoryIcon: EV,
      location: "Singapore",
      rating: "4.0",
      description:
        "Connecting everything in your enterprise from shop floor to the top floor. Collecting critical data, analysing data and discover meaningful insights.",
      developer: "Schneider Electric",
      techAdoption: "AI, IoT, Data Analytics",
      solution: "EV Solutions",
      provider: "EV Hive",
      type: "Services",
    },
    // {
    //   title: "Siemens Intelligent Traffic Systems (ITS)",
    //   category: "Road ",
    //   categoryIcon: Simens,
    //   location: "Singapore",
    //   rating: "4.0",
    //   description:
    //     "Siemens ITS provides all necessary elements for complex, efficient traffic management.",
    //   developer: "Siemens",
    //   techAdoption: "AI, IoT, Data Analytics",
    // },
    // {
    //   title: "Energy Assessment",
    //   category: "Energy ",
    //   categoryIcon: Intel,
    //   location: "Worldwide",
    //   rating: "4.9",
    //   description:
    //     " Intel powers the edge computing and smart energy IoT solutions that help producers, distributors, and consumers understand and optimize their energy usage",
    //   developer: "Intel",
    //   techAdoption: " IoT, Sensors, AI",
    // },
    // {
    //   title: "Enabling Smart Energy and Energy IOT",
    //   category: "Energy ",
    //   categoryIcon: Intel,
    //   location: "Worldwide",
    //   rating: "4.9",
    //   description:
    //     " Intel powers the edge computing and smart energy IoT solutions that help producers, distributors, and consumers understand and optimize their energy usage",
    //   developer: "Intel",
    //   techAdoption: " IoT, Sensors, AI",
    // },
    // {
    //   title: "EV charging one stop solutions",
    //   category: "Energy ",
    //   categoryIcon: Electric,
    //   location: "Singapore",
    //   rating: "4.5",
    //   description:
    //     "We supply the best value EV charging, help the installation including the charging management system, and provide maintenance services",
    //   developer: " Lim Kim Hai electric",
    //   techAdoption: "Analytics",
    // },
    {
      id: 33,
      title: "Smart Lighting for Smart Building",
      category: "Energy ",
      categoryIcon: Philips,
      location: "Singapore",
      rating: "4.5",
      type: "Technologies",
      provider: "Philips",
      solution: "Smart Building Solutions",
      description:
        "We supply the best value EV charging, help the installation including the charging management system, and provide maintenance services",
      developer: " Lim Kim Hai electric",
      techAdoption: "Analytics",
    },
    {
      id: 34,
      title: "IoT Devices",
      category: "Energy ",
      categoryIcon: Honeywell,
      location: "Singapore",
      rating: "4.5",
      type: "Technologies",
      provider: "Honeywell",
      solution: "Smart Building Solutions",
      description:
        "We supply the best value EV charging, help the installation including the charging management system, and provide maintenance services",
      developer: " Lim Kim Hai electric",
      techAdoption: "Analytics",
    }
  ],
};
